"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
const ColumnConfig_1 = tslib_1.__importDefault(require("../column-config/ColumnConfig"));
const ExpandingGridLayout_1 = tslib_1.__importDefault(require("./ExpandingGridLayout"));
const GridConstants_1 = tslib_1.__importDefault(require("../GridConstants"));
const HiddenTableHeader_1 = tslib_1.__importDefault(require("../model/HiddenTableHeader"));
class ExpanderColumnConfig extends ColumnConfig_1.default {
    constructor(...args) {
        super({
            headerStyle: new Set(["th-expander"]),
            heading: new HiddenTableHeader_1.default({ headerName: "Udvid/Luk" }),
            mapDataToTD: data => this.render(data),
            mapDataToTDCssClasses: () => ["td-expander"],
            sortable: false
        });
        const { buttonText, expandedButtonText, mapDataToDisableExpand } = this.extractArgs(args);
        this.buttonText = buttonText;
        this.expandedButtonText = expandedButtonText;
        this.mapDataToDisableExpand = mapDataToDisableExpand;
        const that = this;
        this.renderer = {
            render(ctx, button) {
                ctx.setWidget(button);
            },
            canRender(_o) {
                return true;
            },
            postRender() {
                that.currentlyExpandedButton = undefined; // Always set expanded button to undefined when rerender has finished
            }
        };
    }
    render(data) {
        if (this.mapDataToDisableExpand?.(data)) {
            return;
        }
        const ariaControlId = fmko_ts_common_1.GlobalCounter.next();
        const buttonText = this.getButtonText(data, false);
        const expandedButtonText = this.getButtonText(data, true);
        let expandingOrCollapsing = false;
        const expandButton = new fmko_ts_widgets_1.ImageWidget({
            alt: buttonText || "Udvid/Luk",
            imageDimension: fmko_ts_widgets_1.ImageDimensions.XL,
            src: fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.EXPAND)
        });
        fmko_ts_common_1.WCAG.addButtonEvent({
            callback: event => {
                if (expandingOrCollapsing) {
                    return;
                }
                let element = this.grid.getElementForEvent(event);
                while (!(element instanceof HTMLTableElement || element instanceof HTMLTableRowElement)) {
                    element = element.parentElement;
                }
                if (element instanceof HTMLTableRowElement) {
                    const layout = this.findExpandingGridLayout(this.grid);
                    if (this.currentlyExpandedButton && this.currentlyExpandedButton !== expandButton) {
                        this.currentlyExpandedButton.element.setAttribute(fmko_ts_common_1.ARIA.EXPANDED, "false");
                    }
                    const expanded = layout.expandOrCollapse(data, element, ariaControlId);
                    expandingOrCollapsing = true;
                    setTimeout(() => {
                        expandingOrCollapsing = false;
                    }, GridConstants_1.default.EXPANDING_HEIGHT_TRANSITION_TIMING);
                    expandButton.element.setAttribute(fmko_ts_common_1.ARIA.EXPANDED, `${expanded}`);
                    expandButton.setAlt(expanded ? expandedButtonText : buttonText);
                    this.currentlyExpandedButton = expanded ? expandButton : undefined;
                }
            },
            element: expandButton.element
        });
        expandButton.element.setAttribute(fmko_ts_common_1.ARIA.CONTROLS, ariaControlId);
        expandButton.element.setAttribute(fmko_ts_common_1.ARIA.EXPANDED, "false");
        return expandButton;
    }
    isSortable() {
        return false;
    }
    /**
     * Override to calculate a row-specific button text
     * @param data data for current row
     * @param expanded row is currently expanded
     * @returns the button text
     */
    getButtonText(data, expanded) {
        if (expanded && this.expandedButtonText) {
            return this.expandedButtonText;
        }
        return this.buttonText;
    }
    findExpandingGridLayout(grid) {
        let gridLayout = grid.getGridLayout();
        while (gridLayout) {
            if (gridLayout instanceof ExpandingGridLayout_1.default) {
                return gridLayout;
            }
            gridLayout = gridLayout.getDelegate();
        }
        return null;
    }
    extractArgs(args) {
        if (typeof args[0] === "string") { // If first arg is string then it's the old constructor
            const [buttonText, expandedButtonText, mapDataToDisableExpand] = args;
            return { buttonText, expandedButtonText, mapDataToDisableExpand };
        }
        return args[0];
    }
}
exports.default = ExpanderColumnConfig;
//# sourceMappingURL=ExpanderColumnConfig.js.map